var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 7.49755C2.32884 7.49755 2.96453 7.76086 3.43322 8.22955C3.90191 8.69824 4.16522 9.33392 4.16522 9.99675C4.16522 10.6596 3.90191 11.2953 3.43322 11.764C2.96453 12.2326 2.32884 12.4959 1.66602 12.4959V14.1621C1.66602 14.604 1.84155 15.0278 2.15401 15.3402C2.46648 15.6527 2.89026 15.8282 3.33215 15.8282H16.6612C17.1031 15.8282 17.5269 15.6527 17.8393 15.3402C18.1518 15.0278 18.3273 14.604 18.3273 14.1621V12.4959C17.6645 12.4959 17.0288 12.2326 16.5601 11.764C16.0915 11.2953 15.8281 10.6596 15.8281 9.99675C15.8281 9.33392 16.0915 8.69824 16.5601 8.22955C17.0288 7.76086 17.6645 7.49755 18.3273 7.49755V5.83142C18.3273 5.38953 18.1518 4.96574 17.8393 4.65328C17.5269 4.34082 17.1031 4.16528 16.6612 4.16528H3.33215C2.89026 4.16528 2.46648 4.34082 2.15401 4.65328C1.84155 4.96574 1.66602 5.38953 1.66602 5.83142V7.49755Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8298 4.16528V5.83142",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8298 14.1621V15.8282",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8298 9.16382V10.83",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9936,
    height: 19.9936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.a20b22e57028376085db36947cc064f4.svg";
export { ForwardRef as ReactComponent };